import api from './client';

export type SearchResultKind = 'player' | 'report' | 'match' | 'calendar_event' | 'league_match' | 'league_player';
export interface SearchResult { kind: SearchResultKind; id: string; title: string; description: string; href: string }
export interface SearchResponse { data: SearchResult[]; meta: { query: string; total: number } }

const canonicalDestination = /^\/(players|scouting|reports|matches|calendar|league)(?:[/?#]|$)/;

export const searchAPI = {
  search: async (workspaceId: string, query: string, signal?: AbortSignal): Promise<SearchResponse> => {
    const response = await api.get<SearchResponse>('/v2/search', {
      params: { q: query, limit: 18 },
      headers: { 'X-Workspace-ID': workspaceId },
      signal,
    });
    return { ...response.data, data: response.data.data.filter(result => canonicalDestination.test(result.href) && !result.href.startsWith('//')) };
  },
};
